<template>
<!--    <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">-->
        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields"
                         :skeleton="isLoading">
        </TemplateBuilder>
<!--    </Form>-->
</template>

<script>
    // import { Form } from "ant-design-vue";
    import { defineAsyncComponent, defineComponent, reactive } from "vue";
    import { state as stateApp } from "../../../../../app.logic";
    import { initForm } from "./attachment-full-vessel.logic";

    export default defineComponent({
        components: {
            // Form,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder"))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            viewOnly: { default: false },
            dataProp: {},
            dataKey: {},
            labelExampleImage: {},
            attachmentGroup: {},
            canCreate: {},
            canDelete: {},
            isLoading: {},
            previewPicture: {},
            isShowOriginalVesselAttachment: { default: false },
            hiddenPreviewButton: { default: false }
        },
        setup(props) {
            const data = reactive({ ...props.dataProp });
            const refs = reactive({ form: null });
            initForm({ props, data, refs });
            return {
                props,
                data,
                refs
            };
        }
    });
</script>
